module.exports = __webpack_public_path__ + "static/media/investment-money.5b0db3ec.svg";